import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Mic, Crown } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Button } from './ui/button';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

/**
 * Compact voice-usage display.
 *
 * Reads /api/payments/subscription/status which exposes voice_used_today
 * and voice_limit (added in the e+d ship).
 *
 * Props:
 *   showUpgradeCta — true to render the upgrade button + helper text below the line (used on /subscription)
 */
const VoiceUsageCard = ({ showUpgradeCta = false }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [status, setStatus] = useState(null);

  useEffect(() => {
    let mounted = true;
    axios
      .get(`${API}/payments/subscription/status`, { withCredentials: true })
      .then((res) => mounted && setStatus(res.data))
      .catch(() => {});
    return () => {
      mounted = false;
    };
  }, []);

  if (!status) return null;

  const isPremium = status.status === 'premium';
  const used = status.voice_used_today ?? 0;
  const limit = status.voice_limit ?? 5;

  return (
    <div className="hussar-voice-usage" data-testid="voice-usage-card">
      <div className="hussar-voice-usage-row">
        <Mic className="hussar-voice-usage-icon" />
        <span className="hussar-voice-usage-label">
          {isPremium ? t('settings.voiceUsagePremium') : t('settings.voiceUsageFree', { used, limit })}
        </span>
      </div>
      {!isPremium && showUpgradeCta && (
        <>
          <p className="hussar-voice-usage-helper">{t('settings.voiceUsageHelper')}</p>
          <Button
            onClick={() => navigate('/subscription')}
            className="hussar-btn-primary hussar-btn-sm"
            data-testid="voice-usage-upgrade-btn"
          >
            <Crown className="w-4 h-4" />
            {t('subscription.goPremium')}
          </Button>
        </>
      )}
    </div>
  );
};

export default VoiceUsageCard;
